import { useMemo } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Link, Route, Routes } from 'react-router-dom';
import { ApiClient } from './api';
import { ApiContext } from './apiContext';
import { env, loginRequest } from './authConfig';
import WikiPicker from './pages/WikiPicker';
import WikiView from './pages/WikiView';

function SignIn() {
  const { instance } = useMsal();
  return (
    <div className="signin">
      <div className="signin-card">
        <h1>Wiki Editor</h1>
        <p>Edit Azure DevOps wikis with a proper editor. Sign in with your endpointas.com account.</p>
        <button className="btn btn-primary" onClick={() => instance.loginRedirect(loginRequest)}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

function Header() {
  const { instance, accounts } = useMsal();
  const name = accounts[0]?.name ?? accounts[0]?.username ?? '';
  return (
    <header className="app-header">
      <Link to="/" className="brand">
        <span className="brand-mark">W</span> Wiki Editor
      </Link>
      <span className="spacer" />
      <a className="header-link" href={`https://dev.azure.com/${env.adoOrg}`} target="_blank" rel="noreferrer">
        Azure DevOps
      </a>
      <span className="user-name" title={accounts[0]?.username}>{name}</span>
      <button className="btn btn-ghost" onClick={() => instance.logoutRedirect()}>
        Sign out
      </button>
    </header>
  );
}

export default function App() {
  const { instance } = useMsal();
  const api = useMemo(() => new ApiClient(instance), [instance]);

  return (
    <ApiContext.Provider value={api}>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <div className="app">
          <Header />
          <Routes>
            <Route path="/" element={<WikiPicker />} />
            <Route path="/wiki/:project/:wiki/*" element={<WikiView />} />
          </Routes>
        </div>
      </AuthenticatedTemplate>
    </ApiContext.Provider>
  );
}
